<template>
  <div>
      <b-modal centered hide-footer  id="RequestModal"  title="Aprovação" :no-close-on-backdrop="true">
                 <div v-if="request.status != 4"> <!--  -->
                   <div class="popupRequest" v-if="popupPage == 1">
                      <div class="icone"> <i class="fas fa-thumbs-up"></i> </div>
                      <div class="popupTitle"> Deseja aprovar o cadastro? </div>
                      <div> <button class="greenButton" v-on:click="approve"> APROVAR </button> </div>
                      <div v-if="selectedSolicitacao.status != 3"> <button class="whiteButton" v-on:click="pendency"> ADICIONAR PENDÊNCIA </button> </div>
                    </div>
                    <div class="popupRequest" v-if="popupPage == 2">
                        <div class="title-popupRequest-pt2"> Atenção! </div>
                        <div v-if="requestsRepproved.length > 0">
                          <div class="subtitle-popupRequest-pt2"> Ao aprovar esta solicitação, ocorrerá o cancelamento automático das solicitações abaixo: </div>
                          <div :class="requestsRepproved.length > 5 ? 'list-popupRequest-box' : ''">
                            <div v-for="request in requestsRepproved" :key="request.id" class="list-popupRequest-pt2">
                              {{request.cliente.nome}} - {{request.empreendimento.nome}}
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <div class="subtitle-popupRequest-pt2">Tem certeza que deseja aprovar essa solicitação? </div>
                        </div>
                        <div class="btn-pt2">
                          <div> <button class="whiteButton-2" v-on:click="close"> CANCELAR </button> </div>
                          <div> <button class="greenButton-2" v-on:click="approveRequest(id)"> APROVAR </button> </div>
                        </div>
                    </div>
                    <div class="popupRequest" v-if="popupPage == 3">
                      <div class="subtitle-popupRequest-pt3"> Adicione um motivo para a reprova </div>
                      <textarea v-model="pendencia" class="textareaRequest" placeholder="Adicione uma breve observação sobre o motivo da reprova">  </textarea>
                      <div class="btn-pt2">
                            <div> <button class="whiteButton-2" v-on:click="close"> CANCELAR </button> </div>
                            <div> <button class="greenButton-2" v-on:click="repproveRequest(id,pendencia)"> REPROVAR </button> </div>
                      </div>
                    </div>
                    <div class="popupRequest" v-if="popupPage == 4">
                      <div class="subtitle-popupRequest-pt3"> Adicione a pendência da solicitação </div>
                      <textarea v-model="pendencia" class="textareaRequest" placeholder="Adicione uma breve observação sobre a pendência">  </textarea>
                      <div class="btn-pt2">
                            <div> <button class="whiteButton-2" v-on:click="close"> CANCELAR </button> </div>
                            <div> <button class="greenButton-2" v-on:click="pendencyRequest(id,pendencia)"> ENVIAR </button> </div>
                      </div>
                    </div>
                 </div>

                <div class="popupRequest" v-if="request.status == 4">
                  <div class="title-popupRequest-pt2"> Atenção! </div>
                  <div>
                    <div class="subtitle-popupRequest-pt2">Tem certeza que deseja aprovar essa solicitação? </div>
                  </div>
                  <div class="btn-pt2">
                    <div> <button class="whiteButton-2" v-on:click="close"> CANCELAR </button> </div>
                    <div> <button class="greenButton-2" v-on:click="resolvePending(id)"> APROVAR </button> </div>
                  </div>
                </div>
            </b-modal>
  </div>
</template>

<script>

import modalRequest from './modalRequest'
export default modalRequest

</script>

<style scoped>
 .\.classbuttonclose {
          display: flex;
          justify-content: end;
        }

        .btnApproveRequest{
          background: #008148 0% 0% no-repeat padding-box;
          border-radius: 4px;
          border: none;
          color: #fff;
          font: normal normal 600 16px/21px Segoe UI;
        }

        .popupRequest{
          display: grid;
          justify-content: center;
          align-items: center;
          justify-items: center;
          gap: 1rem;
        }

        .btn-pt2{
          display: flex;
          gap: 2em;
        }

        .icone{
          font-size: 24pt;
          color:#008148;
        }

        .popupTitle{
                font: normal normal 600 20px/27px Segoe UI;
                letter-spacing: 0px;
                color: #2A2A2A;
        }

        .greenButton{
          background: #008148 0% 0% no-repeat padding-box;
          border-radius: 4px;
          width: 397px;
          height: 45px;
          font: normal normal 600 18px/27px Segoe UI;
          color: #FFFFFF;
          border: none;
        }

         .greenButton-2{
          background: #008148 0% 0% no-repeat padding-box;
          border-radius: 4px;
          width: 221px;
          height: 45px;
          font: normal normal 600 18px/27px Segoe UI;
          color: #FFFFFF;
          border: none;
        }

        .redButton{
          background: #DB3939 0% 0% no-repeat padding-box;
          border-radius: 4px;
          width: 397px;
          height: 45px;
          font: normal normal 600 18px/27px Segoe UI;
          color: #FFFFFF;
          border: none;
        }

        .whiteButton{
          background: #CFCFCF 0% 0% no-repeat padding-box;
          border-radius: 4px;
          width: 300px;
          height: 45px;
          font: normal normal 600 18px/27px Segoe UI;
          color: #707070;
          border: none;
        }

        .whiteButton-2{
          background: #CFCFCF 0% 0% no-repeat padding-box;
          border-radius: 4px;
          width: 221px;
          height: 45px;
          font: normal normal 600 18px/27px Segoe UI;
          color: #707070;
          border: none;
        }

        .title-popupRequest-pt2{
         font: normal normal bold 32px/43px Segoe UI;
         letter-spacing: 0px;
         color: #008148;
        }

        .subtitle-popupRequest-pt2{
         font: normal normal normal 20px/27px Segoe UI;
         letter-spacing: 0px;
         color: #2A2A2A;
         padding-bottom: 10px;
        }
        .list-popupRequest-box{
          overflow-y: scroll;
          height: 200px;
        }

        .list-popupRequest-pt2{
          font: normal normal 600 22px/30px Segoe UI;
          letter-spacing: 0px;
          color: #2A2A2A;
          text-align: center;
        }

        .classbuttonclose{
         display: flex;
         justify-content: end;
        }

        .buttonclose{
         border-radius: 50%;
         border: none;
         background: #A8A8A8;
         color: white ;
         opacity: 100%;
         height: 20px;
         text-align: center;
        }

        .textareaRequest{
          resize: none;
          width: 452px;
          height: 92px;
          font: normal normal normal 18px/27px Segoe UI;
        }

        .subtitle-popupRequest-pt3{
          font: normal normal 600 20px/27px Segoe UI;
          letter-spacing: 0px;
          color: #2A2A2A;
        }
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/requests/components/modalRequest/modalRequest.vue